<template>
  <div class="services-page">
    <el-row :gutter="16" class="mb-4">
      <el-col :span="6">
        <el-select v-model="selectedGroup" placeholder="Группа" clearable filterable>
          <el-option v-for="group in groups" :key="group.id" :label="group.name" :value="group.id" />
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-select v-model="selectedCity" placeholder="Город" clearable filterable>
          <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id" />
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-input v-model="searchText" clearable placeholder="Поиск услуги..." />
      </el-col>
      <el-col :span="6" class="text-right">
        <el-button type="primary" @click="openServiceModal">+ Добавить услугу</el-button>
        <el-button @click="openGroupModal">Группы</el-button>
      </el-col>
    </el-row>

    <el-table :data="filteredServices" border>
      <el-table-column prop="name" label="Название услуги" />
      <el-table-column prop="group_name" label="Группа" />
      <el-table-column prop="city_name" label="Город" />
      <el-table-column prop="price" label="Цена" width="110" />
      <el-table-column prop="duration" label="Длит., мин" width="90" />
      <el-table-column label="Действия" width="120">
        <template #default="scope">
          <el-button size="small" :icon="EditPen" @click="editService(scope.row)" />
          <el-button size="small" :icon="Delete" type="danger" @click="confirmDeleteService(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :total="total"
      :page-sizes="[10, 20, 50, 100]"
      layout="total, sizes, prev, pager, next, jumper"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
      class="mt-4 text-right"
    />

    <!-- Модалка для создания/редактирования услуги -->
    <el-dialog v-model="showServiceModal" :title="serviceForm.id ? 'Редактировать услугу' : 'Добавить услугу'">
      <el-form
        :model="serviceForm"
        :rules="serviceRules"
        ref="serviceFormRef"
        label-width="auto"
        label-position="right"
        status-icon>
        <el-form-item label="Название" prop="name">
          <el-input v-model="serviceForm.name" />
        </el-form-item>
        <el-form-item label="Группа" prop="group_id">
          <el-select v-model="serviceForm.group_id" placeholder="Выберите группу" filterable>
            <el-option
              v-for="group in groups"
              :key="group.id"
              :label="group.name"
              :value="group.id"
            />
          </el-select>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="showGroupAdd = true" style="margin-top: 6px">Добавить группу</el-button>
        </el-form-item>
        <el-dialog v-model="showGroupAdd" title="Новая группа" width="340px" append-to-body>
          <el-input v-model="newGroupName" placeholder="Название группы" />
          <template #footer>
            <el-button @click="showGroupAdd = false">Отмена</el-button>
            <el-button type="primary" @click="addGroup">Добавить</el-button>
          </template>
        </el-dialog>
        <el-form-item label="Город" prop="city_id">
          <el-select v-model="serviceForm.city_id" placeholder="Выберите город" filterable>
            <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="Цена" prop="price">
          <el-input-number v-model="serviceForm.price" :min="0" />
        </el-form-item>
        <el-form-item label="Длительность (мин)" prop="duration">
          <el-input-number v-model="serviceForm.duration" :min="5" :step="5" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showServiceModal = false">Отмена</el-button>
        <el-button type="primary" @click="saveServiceHandler">Сохранить</el-button>
      </template>
    </el-dialog>

    <!-- Модалка для управления группами -->
    <el-dialog v-model="showGroupModal" title="Группы услуг">
      <el-table :data="groups" border>
        <el-table-column prop="name" label="Название группы" />
        <el-table-column label="Действия" width="120">
          <template #default="scope">
            <el-button size="small" :icon="EditPen" @click="editGroup(scope.row)" />
            <el-button size="small" :icon="Delete" type="danger" @click="confirmDeleteGroup(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-2">
        <el-input v-model="groupName" placeholder="Новая группа" style="width: 220px;" class="mr-2" />
        <el-button type="primary" @click="addGroupHandler">Добавить</el-button>
      </div>
      <template #footer>
        <el-button @click="showGroupModal = false">Закрыть</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Delete, EditPen } from '@element-plus/icons-vue'

export default {
  name: 'ServicesPage',
  data() {
    return {
      selectedGroup: null,
      selectedCity: null,
      searchText: '',
      showServiceModal: false,
      showGroupModal: false,
      serviceForm: {
        id: null,
        name: '',
        group_id: null,
        city_id: null,
        price: 0,
        duration: 30
      },
      groupName: '',
      showGroupAdd: false,
      newGroupName: '',
      serviceRules: {
        name: [{ required: true, message: 'Укажите название услуги', trigger: 'blur' }],
        group_id: [{ required: true, message: 'Выберите группу', trigger: 'change' }],
        city_id: [{ required: true, message: 'Выберите город', trigger: 'change' }],
        price: [{ required: true, type: 'number', message: 'Укажите цену', trigger: 'blur' }],
        duration: [{ required: true, type: 'number', message: 'Укажите длительность', trigger: 'blur' }]
      },
      page: 1,
      pageSize: 30
    }
  },
  computed: {
    Delete() { return Delete },
    EditPen() { return EditPen },
    ...mapState('services', ['services', 'groups', 'total']),
    ...mapState('cities', ['cities']),
    filteredServices() {
      return this.services.map(s => ({
        ...s,
        group_name: this.groups.find(g => g.id === s.group_id)?.name || '',
        city_name: this.cities.find(c => c.id === s.city_id)?.name || ''
      }))
    }
  },
  mounted() {
    this.fetchServices()
    this.fetchGroups()
    this.getCities()
  },
  watch: {
    selectedGroup() { this.page = 1; this.fetchPage() },
    selectedCity() { this.page = 1; this.fetchPage() },
    searchText() { this.page = 1; this.fetchPage() }
  },
  methods: {
    ...mapActions('services', {
      fetchServices: 'fetchServices',
      saveServiceAction: 'saveService',
      updateServiceAction: 'updateService',
      deleteServiceAction: 'deleteService',
      fetchGroups: 'fetchGroups',
      saveGroup: 'saveGroup',
      updateGroup: 'updateGroup',
      deleteGroup: 'deleteGroup'
    }),
    ...mapActions('cities', ['getCities']),

    async addGroup() {
      if (!this.newGroupName.trim()) return;
      const group = await this.$store.dispatch('services/saveGroup', { name: this.newGroupName });
      this.newGroupName = '';
      this.showGroupAdd = false;
      this.$store.dispatch('services/fetchGroups');
      if (group?.id) this.serviceForm.group_id = group.id;
    },
    openServiceModal() {
      this.serviceForm = { id: null, name: '', group_id: null, city_id: null, price: 0, duration: 30 }
      this.showServiceModal = true
    },
    editService(row) {
      this.serviceForm = { ...row }
      this.showServiceModal = true
    },
    async saveServiceHandler() {
      this.$refs.serviceFormRef.validate(async (valid) => {
        if (valid) {
          if (this.serviceForm.id) {
            await this.updateServiceAction(this.serviceForm)
          } else {
            await this.saveServiceAction(this.serviceForm)
          }
          this.showServiceModal = false
          this.fetchPage()
        }
      })
    },
    // ---- ПОДТВЕРЖДЕНИЕ УДАЛЕНИЯ ----
    confirmDeleteService(row) {
      this.$confirm(
        `Удалить услугу "${row.name}"? Это действие необратимо.`,
        'Подтверждение удаления',
        { type: 'warning' }
      ).then(() => {
        this.deleteServiceHandler(row)
      }).catch(() => {})
    },
    async deleteServiceHandler(row) {
      await this.deleteServiceAction(row.id)
      this.fetchPage()
    },
    openGroupModal() {
      this.groupName = ''
      this.showGroupModal = true
    },
    async addGroupHandler() {
      if (this.groupName.trim()) {
        await this.saveGroup({ name: this.groupName })
        this.groupName = ''
        this.fetchGroups()
      }
    },
    editGroup(row) {
      console.debug(row)
      this.$message.info('Реализуй редактирование группы по своему желанию');
    },
    // ---- ПОДТВЕРЖДЕНИЕ УДАЛЕНИЯ ГРУППЫ ----
    confirmDeleteGroup(row) {
      this.$confirm(
        `Удалить группу "${row.name}"? Удаление возможно только если нет связанных услуг.`,
        'Подтверждение удаления',
        { type: 'warning' }
      ).then(() => {
        this.deleteGroupHandler(row)
      }).catch(() => {})
    },
    async deleteGroupHandler(row) {
      await this.deleteGroup(row.id)
      this.fetchGroups()
      this.fetchPage()
    },
    async fetchPage() {
      const filters = {
        group_id: this.selectedGroup,
        city_id: this.selectedCity,
        search: this.searchText,
        page: this.page,
        pageSize: this.pageSize
      }
      await this.fetchServices(filters);
    },
    handlePageChange(val) {
      this.page = val
      this.fetchPage()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.fetchPage()
    },
  }
}
</script>

<style scoped>
.services-page {
  max-width: 1150px;
  margin: 0 auto;
  padding: 24px 0;
}
</style>
